:host {
  display: block;
  margin-bottom: 20px;
}

.logos__description img {
  margin: 16px 0;
  max-width: 500px;
}
